module.exports = require("/home/vincent/Documents/Develop/Web/PersonalWebsite/website/config/gatsby-browser.ts");